import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="relative overflow-hidden rounded-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=warm%20gradient%20background%20soft%20coral%20and%20cream%20tones%20abstract%20flowing%20shapes%20elegant%20organic%20texture%20minimalist%20composition%20gentle%20light%20rays%20artistic%20atmosphere%20subtle%20grain%20texture%20dreamy%20warm%20mood&width=1600&height=500&seq=cta-background&orientation=landscape"
            alt="韩漫网站CTA"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/80"></div>

          <div className="relative z-10 py-14 md:py-16 px-6 md:px-10 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
              准备好开始你的韩漫之旅了吗？
            </h2>
            <p className="text-sm md:text-base text-white/80 max-w-lg mx-auto mb-7">
              数千部热门韩漫等你来发现。<em className="not-italic font-semibold text-white">免费下拉式</em>阅读，<em className="not-italic font-semibold text-white">智能预加载</em>，随时随地畅享韩漫世界。
            </p>
            <Link
              to="/category/romance"
              className="inline-block px-8 py-3.5 bg-white text-primary-600 rounded-full text-sm font-semibold hover:bg-foreground-50 transition-all cursor-pointer whitespace-nowrap"
            >
              立即免费阅读
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}